export function ErrorBox({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div role="alert" style={{ textAlign: "center", padding: "2rem 1rem" }}>
      <p style={{ fontFamily: "var(--font-title)", color: "var(--color-ink)", margin: "0 0 1rem" }}>{message}</p>
      <button
        type="button"
        onClick={onRetry}
        style={{
          padding: "0.75rem 1.25rem",
          borderRadius: "var(--radius-card)",
          border: "1px solid var(--color-border)",
          background: "var(--color-surface)",
          color: "var(--color-ink)",
          cursor: "pointer",
          font: "inherit",
          fontFamily: "var(--font-cta)",
        }}
      >
        Try again
      </button>
    </div>
  );
}
